var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_247_landing_page_flatline",
    "data-name": "#247_landing_page_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.07,40.93V232.35a6.18,6.18,0,0,1-6.18,6.17H79.82a6.17,6.17,0,0,1-6.17-6.17V40.93a6.17,6.17,0,0,1,6.17-6.17H184.89A6.18,6.18,0,0,1,191.07,40.93Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,34.76a6.18,6.18,0,0,1,6.18,6.17V232.35a6.18,6.18,0,0,1-6.18,6.17H79.82a6.17,6.17,0,0,1-6.17-6.17V40.93a6.17,6.17,0,0,1,6.17-6.17H184.89m0-1H79.82a7.17,7.17,0,0,0-7.17,7.17V232.35a7.18,7.18,0,0,0,7.17,7.17H184.89a7.19,7.19,0,0,0,7.18-7.17V40.93a7.18,7.18,0,0,0-7.18-7.17Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,40.92v71a92.07,92.07,0,0,1-9.21,6.57l-.26.16c-1.38.86-2.79,1.69-4.22,2.47-1.13.64-2.28,1.24-3.44,1.81l-.05,0-.45.23h0l-.48.23c-.76.37-1.52.72-2.29,1.07l-.12,0-.33.15-.44.19-.15.07-.17.07-.11.05-.2.08-.2.08c-.09,0-.19.08-.28.12l-.22.09c-.4.18-.79.34-1.19.5l-.94.37-.44.17-.44.17a92.34,92.34,0,0,1-11.26,3.46l-1.68.38-.5.11c-.49.11-1,.21-1.48.3a93.36,93.36,0,0,1-18.13,1.77,92.91,92.91,0,0,1-12.89-.89c-.6-.08-1.2-.16-1.79-.27l-.83-.13-.5-.08-.51-.09h-.08l-1-.19-.56-.11a5.41,5.41,0,0,1-.58-.12l-.83-.17-.49-.11-.08,0c-.15,0-.3-.06-.44-.09l-.15,0a2.22,2.22,0,0,1-.37-.09c-.54-.12-1.08-.25-1.61-.4l-.58-.14-.59-.15-.87-.24-.59-.16-.59-.16a91.56,91.56,0,0,1-14.28-5.43A93,93,0,0,1,73.64,112v-71a6.17,6.17,0,0,1,6.17-6.17H184.88A6.18,6.18,0,0,1,191.06,40.92Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,43.9h-7a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,91.73,43.9Z",
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,46.67h-7a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z",
    fill: "#0B1B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,49.44h-7a.5.5,0,0,1,0-1h7a.5.5,0,1,1,0,1Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.73,152.1H103a4.5,4.5,0,1,1,0-9h58.75a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,167.87H93.12a4.5,4.5,0,0,1,0-9h78.46a4.5,4.5,0,1,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,176.72H98.73a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H166a.5.5,0,0,1,.5.5A.5.5,0,0,1,166,176.72Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,183.14H98.73a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H166a.5.5,0,0,1,.5.5A.5.5,0,0,1,166,183.14Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.54,189.55H105.16a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h54.38a.5.5,0,0,1,.5.5A.5.5,0,0,1,159.54,189.55Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.73,
    y: 201.45,
    width: 67.24,
    height: 14.58,
    rx: 5.95,
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.43,
    cy: 228.06,
    r: 2.11,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,230.67a2.61,2.61,0,1,1,2.61-2.61A2.61,2.61,0,0,1,127.43,230.67Zm0-4.22a1.61,1.61,0,1,0,1.61,1.61A1.61,1.61,0,0,0,127.43,226.45Z",
    fill: "#0B1B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.27,230.67a2.61,2.61,0,1,1,2.61-2.61A2.61,2.61,0,0,1,137.27,230.67Zm0-4.22a1.61,1.61,0,1,0,1.61,1.61A1.61,1.61,0,0,0,137.27,226.45Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,46.67H119.59a.5.5,0,0,1,0-1h25.53a.5.5,0,0,1,0,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,70.74s1.44-2.33,3.73-5.52c0,0,6.33,5.35,6.29,5.07S95.86,70.74,95.86,70.74Z",
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,69.77c-.08,0-.23-.16-.43-.29s-.41-.33-.68-.53l-.63-.53c-1.1-.9-2.55-2.08-3.93-3.26l-.4-.33,0,0a.5.5,0,0,0-.41-.11.25.25,0,0,0-.16,0,.54.54,0,0,0-.21.16c-1.68,2.35-2.92,4.25-3.44,5.08l0,0a0,0,0,0,1,0,0,1.64,1.64,0,0,0-.17.26s-.07.1-.12.16a1.17,1.17,0,0,0,0,.11.62.62,0,0,0,.07.44.57.57,0,0,0,.42.26h.08l.3,0L99.49,71l.54,0a5,5,0,0,1,.54,0c2.57-.16,4.67-.26,5.11-.2a.41.41,0,0,0,.46,0,.53.53,0,0,0,.27-.56C106.39,70,106.37,69.87,106,69.77Zm-6.22.14-.55,0-2.09.16h-.28c.14-.21.29-.46.48-.73s.31-.47.49-.74l.89-1.32.52-.74c.14-.19.28-.38.41-.58l.2.15,2.73,2.31.63.5.65.54.24.19c-.87,0-2.09.08-3.79.19Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,125.28c-.09,0-.19.08-.28.12l-.22.09c-.4.18-.79.34-1.19.5l-.94.37-.44.17-.44.17a92.34,92.34,0,0,1-11.26,3.46l-1.68.38-.5.11c-.49.11-1,.21-1.48.3a93.36,93.36,0,0,1-18.13,1.77,92.91,92.91,0,0,1-12.89-.89c-.6-.08-1.2-.16-1.79-.27l-.83-.13-.5-.08-.51-.09h-.08l-1-.19-.56-.11a5.41,5.41,0,0,1-.58-.12l-.83-.17-.49-.11-.08,0c-.15,0-.3-.06-.44-.09l-.15,0a2.22,2.22,0,0,1-.37-.09c-.54-.12-1.08-.25-1.61-.4l-.58-.14-.59-.15-.87-.24-.59-.16L95.53,73.09a3.54,3.54,0,0,1,.11-1.87,5,5,0,0,1,.21-.48h0a.21.21,0,0,1,0-.06L96,70.5h0a3.17,3.17,0,0,1,1.37-1.1,3.68,3.68,0,0,1,1.47-.32h1.34l3.06-.08h1.68l15.64-.34h0l17-.35h0l1.2,0,3.12-.06h0l11.54-.25a4.82,4.82,0,0,1,4.62,3.74l.33,1.59Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94,73.23l-.35-1.68a5.35,5.35,0,0,0-5.17-4.16l-11.66.24-2.89.08h0l-1.42,0h0l-16.68.34h0l-16.44.34-.82,0h0l-.84,0-2.55,0H98.82a4.35,4.35,0,0,0-1,.11A3.85,3.85,0,0,0,97,69a3.65,3.65,0,0,0-1.29,1l0,0a0,0,0,0,1,0,0,1.64,1.64,0,0,0-.17.26s-.07.1-.12.16a1.17,1.17,0,0,0,0,.11A3.91,3.91,0,0,0,95,73.2l11.42,55.87.59.16.59.16L96.05,73a3,3,0,0,1,.15-1.73,2.49,2.49,0,0,1,.33-.57,0,0,0,0,0,0,0l0,0a2.1,2.1,0,0,1,.61-.54,3,3,0,0,1,1.67-.5h.36l.54,0h.55l3.6-.08.86,0h.85l47.85-1a1.41,1.41,0,0,1,.29,0,4.27,4.27,0,0,1,3.8,3.3l.3,1.49,10.57,52.23.22-.09c.09,0,.19-.07.28-.12l.2-.08.2-.08.11-.05Z",
    fill: "#0B1B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,123.23h0l-.48.23c-.76.37-1.52.72-2.29,1.07l-.12,0-.33.15-.44.19-.15.07-.17.07-.11.05-.2.08-.2.08c-.09,0-.19.08-.28.12l-.22.09c-.4.18-.79.34-1.19.5l-.94.37-.44.17-.44.17a92.34,92.34,0,0,1-11.26,3.46l-1.68.38-.5.11c-.49.11-1,.21-1.48.3a93.36,93.36,0,0,1-18.13,1.77,92.91,92.91,0,0,1-12.89-.89c-.6-.08-1.2-.16-1.79-.27l-.83-.13-.5-.08-.51-.09h-.08l-1-.19-.56-.11a5.41,5.41,0,0,1-.58-.12l-.83-.17-.49-.11-.08,0L100,71l-.11-.54h0l-.11-.55-.07-.31-.11-.54-.11-.54-.18-.91a3,3,0,0,1-.07-1,3.5,3.5,0,0,1,.37-1.3,0,0,0,0,1,0,0,2.39,2.39,0,0,1,.31-.45,3.44,3.44,0,0,1,2.68-1.25l54.6-1.14a4.8,4.8,0,0,1,4.63,3.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,66.06a5.37,5.37,0,0,0-5.18-4.16l-54.6,1.15a4,4,0,0,0-3.11,1.45c-.06.08-.11.16-.16.24a3.71,3.71,0,0,0-.61,2.59,1.85,1.85,0,0,0,.06.39l.17.81.1.53.12.56.06.33.11.54h0l.12.54,12.12,59.37.15,0c.14,0,.29.07.44.09l.08,0,.49.11L100.57,71l-.11-.55-.12-.54,0-.3-.11-.54-.12-.54-.2-1a2.88,2.88,0,0,1,0-1.34,2.25,2.25,0,0,1,.19-.53,1.93,1.93,0,0,1,.29-.47,3,3,0,0,1,2.3-1L157.26,63c.09,0,.18,0,.28,0a4.3,4.3,0,0,1,3.81,3.29l11.57,57.2.48-.23h0l.45-.23.05,0Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.51,124.59l-.33.15-.44.19-.15.07-.17.07-.11.05-.2.08-.2.08c-.09,0-.19.08-.28.12l-.22.09c-.4.18-.79.34-1.19.5l-.94.37-.44.17-.44.17a92.34,92.34,0,0,1-11.26,3.46l-1.68.38-.5.11c-.49.11-1,.21-1.48.3a93.36,93.36,0,0,1-18.13,1.77,92.91,92.91,0,0,1-12.89-.89c-.6-.08-1.2-.16-1.79-.27l-.83-.13-.5-.08-.51-.09h-.08L104.2,74.71l53.64-1.45h.55l.55,0,1.16,0Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.05,69a.54.54,0,0,1,0-1.08l16-.38a.54.54,0,0,1,.55.53.54.54,0,0,1-.53.55l-16,.38Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24,68.6a.55.55,0,0,1-.51-.53.54.54,0,0,1,.53-.55l2.11,0a.54.54,0,0,1,.55.52.54.54,0,0,1-.52.56l-2.12,0Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.76,115a.58.58,0,0,1-.3-.11.55.55,0,0,1-.09-.76l27.36-35.24a.54.54,0,0,1,.76-.1.55.55,0,0,1,.09.76l-27.36,35.24A.54.54,0,0,1,121.76,115Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,126.2l-3.12,4-1.68.38,4-5a.53.53,0,0,1,.75-.09A.54.54,0,0,1,157.26,126.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43,126.4a.61.61,0,0,1-.29-.11.54.54,0,0,1-.11-.76l6.45-8.45a.54.54,0,1,1,.85.66l-6.44,8.44A.54.54,0,0,1,137.43,126.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,123.64A93,93,0,0,1,73.64,112V84.12a9.11,9.11,0,0,1,2.78,3.41c2.39,4.55,2.93,9.71,2.82,14.91.46-4.31,1.5-8.48,4-11.93a3.26,3.26,0,0,1,1.61-1.33c1.83-.52,3.09,1.81,3.46,3.68a44.93,44.93,0,0,1-2.58,25.67c2.25-4.77,4.76-9.83,9.32-12.48.65-.38,1.51-.7,2.12-.25a2.06,2.06,0,0,1,.61,1.62A24.49,24.49,0,0,1,92.13,123.64Z",
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,90.29V112a92.07,92.07,0,0,1-9.21,6.57l-.26.16c-1.28-1.89-2.5-3.83-3.67-5.78a10.79,10.79,0,0,1-1.49-3.21,4,4,0,0,1,.63-3.37.82.82,0,0,1,.51-.35,1,1,0,0,1,.79.34,23.17,23.17,0,0,1,4.94,5.87,101.89,101.89,0,0,1-5.53-11.78,13.82,13.82,0,0,1-1.17-4.57c0-1.76,1.35-6.15,3.84-4.37A5.24,5.24,0,0,1,182,93.83c.65,1.56,1.3,3.13,2,4.68a29.74,29.74,0,0,1-1.27-16c.32-1.63,1.89-5.87,4.39-4.27A4.44,4.44,0,0,1,188.71,81c0,.17.09.33.14.49C189.59,84.42,190.32,87.36,191.06,90.29Z",
    fill: "#0B1B34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.94,
    y: 61.49,
    width: 117.42,
    height: 203.76,
    rx: 6.17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,61.49a6.17,6.17,0,0,1,6.17,6.17V259.08a6.18,6.18,0,0,1-6.17,6.17H215.11a6.17,6.17,0,0,1-6.17-6.17V67.66a6.17,6.17,0,0,1,6.17-6.17H320.19m0-1H215.11a7.18,7.18,0,0,0-7.17,7.17V259.08a7.18,7.18,0,0,0,7.17,7.17H320.19a7.18,7.18,0,0,0,7.17-7.17V67.66a7.18,7.18,0,0,0-7.17-7.17Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,70.63h-7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,227,70.63Z",
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,73.4h-7a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,.5.5A.5.5,0,0,1,227,73.4Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,76.17h-7a.5.5,0,0,1,0-1h7a.5.5,0,0,1,0,1Z",
    fill: "#0B1B34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.03,
    y: 228.18,
    width: 67.24,
    height: 14.58,
    rx: 5.95,
    fill: "#7B2CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,112.47H224.63a4.5,4.5,0,0,1,0-9h18.06a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.17,114.47H256.33a3.68,3.68,0,0,1-3.68-3.67v-5.29a3.68,3.68,0,0,1,3.68-3.68h54.84a3.68,3.68,0,0,1,3.68,3.68v5.29A3.68,3.68,0,0,1,311.17,114.47Zm-54.84-11.64a2.68,2.68,0,0,0-2.68,2.68v5.29a2.68,2.68,0,0,0,2.68,2.67h54.84a2.68,2.68,0,0,0,2.68-2.67v-5.29a2.68,2.68,0,0,0-2.68-2.68Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,136.1H224.63a4.5,4.5,0,0,1,0-9h12.43a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.91,138.11H256.33a3.68,3.68,0,0,1-3.68-3.67v-5.29a3.68,3.68,0,0,1,3.68-3.68h43.58a3.68,3.68,0,0,1,3.67,3.68v5.29A3.68,3.68,0,0,1,299.91,138.11Zm-43.58-11.64a2.68,2.68,0,0,0-2.68,2.68v5.29a2.68,2.68,0,0,0,2.68,2.67h43.58a2.68,2.68,0,0,0,2.67-2.67v-5.29a2.68,2.68,0,0,0-2.67-2.68Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65,159.74h-11a4.5,4.5,0,0,1,0-9h11a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,161.75H256.33a3.68,3.68,0,0,1-3.68-3.68v-5.29a3.68,3.68,0,0,1,3.68-3.67h49.84a3.68,3.68,0,0,1,3.68,3.67v5.29A3.68,3.68,0,0,1,306.17,161.75Zm-49.84-11.64a2.68,2.68,0,0,0-2.68,2.67v5.29a2.68,2.68,0,0,0,2.68,2.68h49.84a2.68,2.68,0,0,0,2.68-2.68v-5.29a2.68,2.68,0,0,0-2.68-2.67Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,183.38H224.63a4.5,4.5,0,0,1,0-9h18.06a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.17,185.39H256.33a3.68,3.68,0,0,1-3.68-3.68v-5.29a3.68,3.68,0,0,1,3.68-3.67h54.84a3.68,3.68,0,0,1,3.68,3.67v5.29A3.68,3.68,0,0,1,311.17,185.39Zm-54.84-11.64a2.68,2.68,0,0,0-2.68,2.67v5.29a2.68,2.68,0,0,0,2.68,2.68h54.84a2.68,2.68,0,0,0,2.68-2.68v-5.29a2.68,2.68,0,0,0-2.68-2.67Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,207H224.63a4.5,4.5,0,0,1,0-9h12.43a4.5,4.5,0,0,1,0,9Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,209H256.33a3.67,3.67,0,0,1-3.68-3.67v-5.29a3.67,3.67,0,0,1,3.68-3.67h35.56a3.67,3.67,0,0,1,3.67,3.67v5.29A3.67,3.67,0,0,1,291.89,209Zm-35.56-11.63a2.68,2.68,0,0,0-2.68,2.67v5.29a2.68,2.68,0,0,0,2.68,2.67h35.56a2.67,2.67,0,0,0,2.67-2.67v-5.29a2.67,2.67,0,0,0-2.67-2.67Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.57,
    cy: 254.79,
    r: 2.11,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,257.4a2.61,2.61,0,1,1,2.61-2.61A2.61,2.61,0,0,1,272.57,257.4Zm0-4.22a1.61,1.61,0,1,0,1.61,1.61A1.61,1.61,0,0,0,272.57,253.18Z",
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.73,257.4a2.61,2.61,0,1,1,2.61-2.61A2.61,2.61,0,0,1,262.73,257.4Zm0-4.22a1.61,1.61,0,1,0,1.61,1.61A1.61,1.61,0,0,0,262.73,253.18Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.41,73.4H254.88a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h25.53a.5.5,0,0,1,.5.5A.5.5,0,0,1,280.41,73.4Z",
    fill: "#0B1B34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.fd187d6e53ec26b6dbaae168972f81d2.svg";
export { ForwardRef as ReactComponent };